import {
  AccountBalance as AreasComunales,
  AccountBalanceWallet,
  AccountTree,
  Assessment,
  Build,
  CheckBox,
  Class,
  Contacts,
  Dashboard,
  EventNote as AreaRes,
  Folder,
  HomeWork as AreaManager,
  HowToReg,
  HowToVote,
  MenuBook as MenuBookIcon,
  Payment,
  People as Residente,
  Search,
  SupervisedUserCircle,
  TrendingUp,
  Transform,
  CallReceived,
  CallMade,
  Ballot,
  Policy,
  SyncAlt,
  Email,
  NotInterested,
  Assignment,
  LocalShippingOutlined,
  Dns,
  VerifiedUser,
  DriveEta,
  Drafts,
  Face,
  Description,
  DeveloperBoard as DeveloperBoardIcon,
  Receipt,
} from "@material-ui/icons"
import PetsIcon from "@material-ui/icons/Pets"

export const getAdministradorSections = tGlobal => [
  {
    id: "nav_inicio",
    subheader: tGlobal("nav_inicio"),
    items: [
      {
        id: "dashboard",
        title: tGlobal("dashboard"),
        icon: Dashboard,
        href: "/administrador/dashboard",
      },
      {
        id: "supports",
        title: "Soportes",
        icon: DeveloperBoardIcon,
        href: "/administrador/supports",
      },
    ],
  },
  {
    id: "nav_comunidad",
    subheader: tGlobal("nav_comunidad"),
    items: [
      {
        id: "areas_comunales",
        title: "Áreas comunales",
        icon: AreasComunales,
        items: [
          {
            id: "areas_admin",
            title: "Administrar Áreas",
            icon: AreaManager,
            href: "/administrador/areascomunales",
          },
          {
            id: "areas_reservas",
            title: "Administrar Reservas",
            icon: AreaRes,
            href: "/administrador/reservasxaprobar",
          },
        ],
      },
      {
        id: "residents",
        title: tGlobal("residents"),
        icon: Residente,
        href: "/administrador/residente",
      },
      {
        id: "unidades",
        title: "Unidades",
        icon: AreaManager,
        href: "/administrador/unidades",
      },
      {
        id: "access_controls",
        title: tGlobal("access_controls"),
        icon: VerifiedUser,
        items: [
          {
            id: "placas",
            title: tGlobal("license_plates"),
            icon: DriveEta,
            href: "/administrador/placas",
          },
          {
            id: "tags",
            title: tGlobal("vehicle_tags"),
            icon: Dns,
            href: "/administrador/tags",
          },
          {
            id: "rostros",
            title: "Rostros",
            icon: Face,
            href: "/administrador/rostros",
          },
        ],
      },
      {
        id: "mudanzas",
        title: tGlobal("removals"),
        icon: LocalShippingOutlined,
        href: "/administrador/mudanza",
      },
      {
        id: "mascotas",
        title: "Mascotas",
        icon: PetsIcon,
        href: "/administrador/mascotas",
      },
    ],
  },
  {
    id: "nav_finanzas",
    subheader: tGlobal("nav_finanzas"),
    items: [
      {
        id: "proveedores",
        title: "Proveedores",
        icon: Contacts,
        items: [
          {
            id: "proveedores_list",
            title: "Proveedores",
            href: "/administrador/proveedores",
          },
          {
            id: "proveedores_cxp",
            title: "Cuentas por pagar",
            href: "/administrador/proveedores/cuentasporpagar",
          },
        ],
      },
      {
        id: "conciliacion",
        title: "Conciliación",
        icon: CheckBox,
        href: "/administrador/conciliar",
      },
      {
        id: "presupuestar",
        title: "Presupuestar",
        icon: TrendingUp,
        href: "/administrador/presupuestar",
      },
      {
        id: "cash_bank_assets",
        title: tGlobal("cash_bank_assets"),
        icon: AccountBalanceWallet,
        items: [
          {
            id: "bank_accounts",
            title: tGlobal("bank_accounts"),
            href: "/administrador/cuentasBancarias",
          },
          {
            id: "cashboxes",
            title: tGlobal("cashboxes"),
            href: "/administrador/cajas",
          },
          {
            id: "assets",
            title: tGlobal("assets"),
            href: "/administrador/activos",
          },
          {
            id: "funds_transfer",
            title: tGlobal("funds_transfer"),
            icon: MenuBookIcon,
            href: "/administrador/historicoFondos",
          },
        ],
      },
      {
        id: "transacciones",
        title: "Transacciones",
        icon: Transform,
        items: [
          {
            id: "ingresos",
            title: "Ingresos",
            icon: CallReceived,
            href: "/administrador/ingresos",
          },
          {
            id: "egresos",
            title: "Egresos",
            icon: CallMade,
            href: "/administrador/egresos",
          },
          {
            id: "cuentas_por_pagar",
            title: "Cuentas por pagar",
            icon: Payment,
            href: "/administrador/cuentasporpagar",
          },
          {
            id: "cruce_cuentas",
            title: "Cruce de cuentas",
            icon: SyncAlt,
            href: "/administrador/crucecuentas",
          },
          {
            id: "ingresos_no_identificados",
            title: "Ingresos no identificados",
            icon: CallReceived,
            href: "/administrador/ingresosNoIdentificados",
          },
          {
            id: "proformas",
            title: "Proformas",
            icon: Description,
            href: "/administrador/proformas",
          },
          {
            id: "anulados",
            title: "Anulados",
            icon: NotInterested,
            href: "/administrador/anulaciones",
          },
        ],
      },
      {
        id: "contifico",
        title: tGlobal("nav_contifico"),
        icon: AccountTree,
        href: "/administrador/contifico",
      },
      {
        id: "rubros",
        title: "Rubros",
        icon: Class,
        items: [
          {
            id: "rubros_ingresos",
            title: "Rubros Ingresos",
            href: "/administrador/rubros/rubrosingresos",
          },
          {
            id: "rubros_egresos",
            title: "Rubros Egresos",
            href: "/administrador/rubros/rubrosegresos",
          },
        ],
      },
      {
        id: "transferencias_pendientes",
        title: "Transferencias pendientes",
        icon: Payment,
        href: "/administrador/transferenciasporaprobar",
      },
      {
        id: "planillas",
        title: "Planillas",
        icon: Receipt,
        href: "/administrador/planillas",
      },
    ],
  },
  {
    id: "nav_comunicacion",
    subheader: tGlobal("nav_comunicacion"),
    items: [
      {
        id: "comunicaciones",
        title: "Comunicaciones",
        icon: Email,
        items: [
          {
            id: "notificaciones",
            title: "Notificaciones",
            href: "/administrador/notificaciones",
          },
          {
            id: "programados",
            title: "Cobros / Vencimientos",
            href: "/administrador/programados",
          },
        ],
      },
      {
        id: "votaciones",
        title: tGlobal("votes"),
        icon: HowToVote,
        items: [
          {
            id: "votacion",
            title: tGlobal("vote"),
            href: "/administrador/votacion",
          },
          {
            id: "encuestas",
            title: tGlobal("surveys"),
            href: "/administrador/encuestas",
          },
        ],
      },
      {
        id: "reportes_danos",
        title: "Reportes de Daños",
        icon: Build,
        items: [
          {
            id: "informe_problemas",
            title: "Reportes de Daños",
            href: "/administrador/informeProblemas",
          },
          {
            id: "mantenimiento",
            title: "Calendario de Mantenimientos",
            href: "/administrador/mantenimiento",
          },
        ],
      },
    ],
  },
  {
    id: "nav_reportes_archivo",
    subheader: tGlobal("nav_reportes_archivo"),
    items: [
      {
        id: "reportes",
        title: "Reportes",
        icon: Ballot,
        items: [
          {
            id: "reporte_ingvsegr",
            title: "Ingresos y Egresos",
            href: "/administrador/reportes/ingvsegr",
          },
          {
            id: "reporte_cuentasporcobrar",
            title: "Cuentas por Cobrar",
            href: "/administrador/reportes/cuentasporcobrar",
          },
          {
            id: "reporte_ingresos",
            title: "Ingresos",
            href: "/administrador/reportes/ingresos",
          },
          {
            id: "reporte_ingresos_anual",
            title: "Ingresos por Año",
            href: "/administrador/reportes/ingresosAnual",
          },
          {
            id: "reporte_egresos",
            title: "Egresos",
            href: "/administrador/reportes/egresos",
          },
          {
            id: "reporte_cartera",
            title: "Cartera Vencida",
            href: "/administrador/reportes/cartera",
          },
          {
            id: "reporte_cartera_usuario",
            title: "Cartera Mensualizada",
            href: "/administrador/reportes/carteraUsuario",
          },
          {
            id: "reporte_historico_cartera",
            title: "Historico de Cartera",
            href: "/administrador/reportes/historicoCartera",
          },
          {
            id: "reporte_consolidado",
            title: "Consolidado",
            href: "/administrador/reportes/consolidado",
          },
          {
            id: "reporte_financiero",
            title: "Financiero",
            href: "/administrador/reportes/financiero",
          },
          {
            id: "bloques",
            title: "Bloques",
            href: "/administrador/reportes/bloques",
          },
        ],
      },
      {
        id: "archivo",
        title: "Archivo",
        icon: Folder,
        href: "/administrador/archivo",
      },
    ],
  },
  {
    id: "nav_seguridad",
    subheader: tGlobal("nav_seguridad"),
    items: [
      {
        id: "gestion_guardia",
        title: "Gestion Guardia",
        icon: Policy,
        items: [
          {
            id: "guardia_listas",
            title: "Listas B/N y Visitas Ant.",
            icon: HowToReg,
            href: "/administrador/gestionGuardia",
          },
          {
            id: "guardias",
            title: "Guardias",
            icon: SupervisedUserCircle,
            href: "/administrador/gestionarGuardias",
          },
          {
            id: "visitas",
            title: "Visitas",
            icon: Assessment,
            href: "/administrador/reportes/visitasGuardia",
          },
          {
            id: "actividad_hora",
            title: "Actividad x Hora",
            icon: Assessment,
            href: "/administrador/reportes/ReporteDiarioVisitas",
          },
        ],
      },
    ],
  },
  {
    id: "nav_sistema",
    subheader: tGlobal("nav_sistema"),
    items: [
      {
        id: "historial_correos",
        title: "Historial de correos",
        icon: Drafts,
        href: "/administrador/historial-correos",
      },
      {
        id: "logs",
        title: tGlobal("logs"),
        icon: Assignment,
        href: "/administrador/logs",
      },
      {
        id: "faq",
        title: "FAQ",
        icon: Search,
        href: "/administrador/faq",
      },
    ],
  },
]
